// Shared types for Preview components

export type ResponseValue =
  | string
  | string[]
  | boolean
  | number
  | { from: number; to: number }
  | { other: string }
  | Array<{ value: string; group: string }>
  | null;

export type QuestionRefWithId = {
  questionId: string;
  visibility: "visible" | { visibleWhen: string };
  requirement: "optional" | "required" | { requiredWhen: string };
};

/**
 * Helper function to check if a response has a valid value
 */
export const hasValidResponse = (value: ResponseValue): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  if (typeof value === "boolean") return true;
  if (typeof value === "number") return true;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") {
    // Handle { other: string } or { from: number, to: number }
    return Object.values(value).some(v => v !== null && v !== undefined && v !== "");
  }
  return false;
};
